import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "~/components";

type VariantHeaderProps = PropsWithChildren<{
  productName: string;
  cta: React.ReactNode;
}>;

export const VariantHeader = ({
  productName,
  children,
  cta
}: VariantHeaderProps) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-row items-center gap-3">
        <Button
          className="aspect-square rounded-full"
          variant="secondary"
          size="large"
          onClick={() => {
            navigate(-1);
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} size="lg" />
        </Button>

        <h1 className="text-4xl font-bold">{productName}</h1>

        {children}
      </div>

      {cta}
    </div>
  );
};
